import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";

export const SportsbookBonusDialog = ({
  showModal,
  setShowModal,
  handleProceed,
  handleCancel,
  skin,
}) => {
  const { t } = useTranslation("");

  const handleDontShowAgain = () => {
    console.log("dont show again");
    setShowModal(false);
    //todo: update profile with sportOptIn = true
  };

  return (
    <StyledModal isOpen={showModal}>
      <StyledModalBody register>{t("label_sport_bonus_optin")}</StyledModalBody>
      <StyledModalFooter>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => handleProceed()}
        >
          {t("label_yes")}
        </StyledButton>
        <StyledButton
          dialog
          pub={skin === "pub"}
          onClick={() => handleCancel()}
        >
          {t("label_dont_show_this_again")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
